import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TestPage} from './test-page/test.page';
import {ZoomPage} from './zoom-page/zoom.page';
import {TalkjsPage} from './talkjs-page/talkjs.page';
import {AuthOnlyGuard} from '../../guards/auth-only.guard';
import {UserInfoResolver} from '../../resolvers/user-info.resolver';
import {YoutubePage} from './youtube-page/youtube.page';

const routes: Routes = [
  {
    path: 'zoom',
    component: TestPage,
    canActivate: [AuthOnlyGuard],
    resolve: {userInfo: UserInfoResolver}
  },
  {
    path: 'zoom-embedded',
    component: ZoomPage,
    canActivate: [AuthOnlyGuard],
    resolve: {userInfo: UserInfoResolver}
  },
  {
    path: 'chat',
    component: TalkjsPage
  },
  {
    path: 'youtube',
    component: YoutubePage
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TestRoutingModule {
}
